import { get, post } from "@services/apiService.js";

let googleReviewsPromise = null;

export default {
  getGoogleMap() {
    return get(`/v4/google-api-manager/v1/google-map/key`)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  setGoogleMapKey(gmapKey) {
    return post(`/v4/google-api-manager/v1/google-map/key`,{gmapKey: gmapKey})
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getGoogleReviews() {
    if (!googleReviewsPromise) {
      googleReviewsPromise = get(`/v4/google-api-web/v1/google-reviews`)
        .then(response => {
          return response.data || {};
        })
        .catch(error => {
          googleReviewsPromise = null;
          throw error;
        });
    }
    return googleReviewsPromise;
  },
}